import { useMemo } from 'react'

import BookingDetailsCardCabinsInfo from './BookingDetailsCardCabinsInfo'
import BookingDetailsCardRoomsInfo from './BookingDetailsCardRoomsInfo'

const BookingDetailsCardAccomodation = ({ order, isCheckout }) => {
  const { shopKind, currency } = order
  return useMemo(() => {
    switch (shopKind) {
      case 10:
        return (
          <BookingDetailsCardCabinsInfo
            order={order}
            currency={currency}
            isCheckout={isCheckout}
          />
        )
      case 20:
        return <BookingDetailsCardRoomsInfo order={order} />
      default:
        return null
    }
  }, [shopKind, currency, order])
}

export default BookingDetailsCardAccomodation
